import React from "react";
import {CopyToClipboard} from "react-copy-to-clipboard";
const os = window.OneSignal || []

export default class OneSignal {
    static init () {
        os.push(function () {
            os.init({
                appId: process.env.NALURI_APP_ONESIGNAL_APP_ID,
                autoRegister: true,
                notifyButton: {
                    enable: true
                }
            });
            os.registerForPushNotifications()
        });
    }

    static sendTags (params) {
        os.push(function () {
            os.getUserId()
                .then(function (userId) {
                    if (userId) {
                        os.push(function () {
                            os.sendTags(params)
                        })
                    }
                })
        })
    }

    static troubleshootPushNotifications = async () => {
        if (os) {
            os.push(function () {
                os.on('notificationDisplay', function (event) {
                    console.warn('OneSignal notification displayed:', event);
                });
            });
            const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            if (isChrome) {
                const result = await Notification.requestPermission()
                if (result === 'denied' || result === 'default') {
                    return <div>You currently have notifications disabled. Enable it to get notified of users messages here<br/> <a href='https://support.google.com/chrome/answer/3220216'>https://support.google.com/chrome/answer/3220216</a></div>
                }
                os.sendSelfNotification('Test Notification From Naluri', 'Web notifications is working on this browser.')
                return <div>Notification permission has been enabled, you should see our test notification shortly.<br/> If you still do not see the notification, click the troubleshooting option again and <b>disable</b> the notification flag here<br/><a href='chrome://flags/#enable-native-notifications'>chrome://flags/#enable-native-notifications</a> <CopyToClipboard text="chrome://flags/#enable-native-notifications"><button className={'button is-white is-small filter-btn'}>Copy</button></CopyToClipboard></div>
            } else {
                os.sendSelfNotification('Test Notification From Naluri', 'Web notifications is working on this browser.')
                return <div>Notification permission has been enabled, you should see our test notification once you click OK.</div>
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/onesignal.js